import { render, staticRenderFns } from "./PubCard.vue?vue&type=template&id=5b8cb9e4&"
import script from "./PubCard.vue?vue&type=script&lang=js&"
export * from "./PubCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports